import { Inject, Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { FREE_SUBSCRIPTION_ID, SubscriptionTiersService } from '@galaxy/partner';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssignedSalespersonService } from '../assigned-salesperson/assigned-salesperson.service';
import { PartnerTrialStoreService, TrialStatus } from '../core/partner';
import { PartnerService } from '../core/partner.service';

export interface TrialDetails {
  onTrial: boolean;
  tierName?: string;
  startDate?: Date;
  endDate?: Date;
  bookMeetingUrl?: string;
  isFree: boolean;
  expired?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TrialBannerService {
  constructor(
    private partnerService: PartnerService,
    private partnerTrialStoreService: PartnerTrialStoreService,
    private assignedSalespersonService: AssignedSalespersonService,
    private trialService: PartnerTrialStoreService,
    @Inject('PARTNER_ID') private partnerId$: Observable<string>,
  ) {}

  public getSalesDialogConfig$(): Observable<MatDialogConfig> {
    return this.assignedSalespersonService.dialogConfig$;
  }

  public getTrialDetails$(): Observable<TrialDetails> {
    const isFree$ = combineLatest([this.partnerService.subscriptionTier$]).pipe(
      map(([tier]) => {
        return tier.id === FREE_SUBSCRIPTION_ID;
      }),
    );

    return combineLatest([this.partnerTrialStoreService.partnerTrial$, isFree$]).pipe(
      map(([trial, isFree]) => {
        const isActive = trial.status === TrialStatus.ACTIVE;
        return {
          onTrial: isActive,
          tierName: SubscriptionTiersService.getI18NName(trial.subscriptionTierId),
          startDate: trial.start,
          endDate: isActive ? trial.end : null, // If the trial is not active, set endDate to null
          isFree: isFree,
          expired: trial.status === TrialStatus.EXPIRED,
        };
      }),
    );
  }
}
